module.exports = __webpack_public_path__ + "img/xxx-sharow-left.1738eb5.png";